/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from "react";
import mapboxgl from "mapbox-gl";
import { api } from "../../services/api";
import { MapaDiv, InfoButton, MapActionBtn } from "./styled";
import ModalInfo from "../../components/ModalInfo";
import ModalPonto from "../../components/ModalPontos";
import Menu from "../../components/Menu";
import Load from "../../components/Load";
import * as IconMD from "react-icons/md";
import { useNavigate } from "react-router-dom";
import iconPI from "./images/iconPI.png";
import "./mapstyle.css";
import axios from "axios";
import useToast from "../../hooks/useToast";
// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from "worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker"; // Load worker code separately with worker-loader

mapboxgl.workerClass = MapboxWorker; // Wire up loaded worker to be used instead of the default
const token =
  "pk.eyJ1IjoiY2hyaXN0aWFub2xpbm8iLCJhIjoiY2s5ZWhnY21zMDBmNDNscDRtNnplNnhqcCJ9.KYxz1mLRgnZdWur4i3k4IQ";
mapboxgl.accessToken = token;
const Map = () => {
  const { showToast } = useToast();
  const mapContainerRef = useRef(null); //Referencia o mapa do mapbox (necessário de acordo com a documentação)
  const [map, setMap] = useState(null); //Seta o mapa
  const [locationsMarker, setLocationsMarker] = useState([]); //Seta a posição inicial
  const [markerUser, setMarkerUser] = useState(null); //Marcador usuário
  const [marker, setMarker] = useState(null); //Marcador unidade
  const [formValues, setFormValues] = useState({}); //Viagem e linha escolhidos no dropdown
  const [formDirection, setFormDirection] = useState({}); //Direção da viagem e linha escolhida no dropdown
  const [load, setload] = useState(false); //Mostra na tela um componente de load
  const [busline, setBusline] = useState([]); //Salva o retorno da API location
  const [routeIsTrue, setRouteIsTrue] = useState(false); //Verifica se há rota desenhada
  const [pointIsTrue, setPointIsTrue] = useState(false); //Verifica se há pontos desenhados
  const [schedulePoint, setschedulePoint] = useState(null); //Salva o retorno da API schedule
  const [pontoIni, setpontoIni] = useState(null); //Armazena o ponto inicial da viagem
  const [pontoFim, setpontoFim] = useState(null); //Armazena o ponto final da viagem
  const [pontos, setpontos] = useState([]); //Armazena o resto dos pontos da viagem
  const [popupInfos, setPopupInfos] = useState([]); //Salva as informações para gerar o popup
  const [eventClick, setEventClick] = useState(false); //Verifica se o evento de click já existe
  const [elementCar, setelementCar] = useState([]); //Seta o display da unidade como none, se o realtime não for nulo, altera para block
  const [enderecos, setEnderecos] = useState([]); //Armazena os endereços dos pontos
  const [modalInfo, setModalInfo] = useState(false);
  const [modalPonto, setModalPonto] = useState(false);
  const [coordenadas, setCoordenadas] = useState([]);
  const [pulsePoints, setPulsePoints] = useState(false);
  const vehicleTrail = useRef([]); // Acumula posições do veículo para desenhar rastro
  const [mapReady, setMapReady] = useState(false);
  const lastVehiclePos = useRef(null); // Última posição conhecida do veículo
  const animationRef = useRef(null); // ID da animação em andamento

  let reloadUserRoute = undefined; // sleep para carga de objetos no mapa baseados no timerReload
  let timerUserReload = 10000; // tempo de atualização dos objetos do mapa
  let reloadRoute = undefined; // sleep para carga de objetos no mapa baseados no timerReload
  let timerReload = 10000; // tempo de atualização dos objetos do mapa

  const address = JSON.parse(localStorage.getItem("addressListFix")); //Pega o endereço salvo pelo usuário, se tiver
  const popupOpen = localStorage.getItem("popup");
  const blsi = localStorage.getItem("BuslineShiftID");

  const ccid = localStorage.getItem("CoastCenterID");
  const urlCCID = new URL(window.location);
  const decodedStr = atob(urlCCID.searchParams.get("ccid"));

  if (ccid == undefined || ccid == null || ccid != decodedStr) {
    if (ccid !== decodedStr && decodedStr !== atob(null)) {
      localStorage.setItem("CoastCenterID", decodedStr);
    } else {
      localStorage.setItem("CoastCenterID", ccid);
    }
  }

  //Salvo na variável formValues o que o usuário escolheu no dropdown de linha e viagem
  const handleLineChange = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  //Salvo na variável formDirection o que o usuário escolheu no dropdown de viagem
  const handleViagemChange = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const getCurrentLocationOfUser = () => {
    if (!markerUser) return;
    try {
      // Lê o endereço salvo a cada chamada para capturar atualizações via long-press
      const savedAddress = JSON.parse(localStorage.getItem("addressListFix"));
      if (savedAddress && savedAddress.length > 0 && savedAddress[0].coords) {
        markerUser.setLngLat([savedAddress[0].coords[0], savedAddress[0].coords[1]]);
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            markerUser.setLngLat([
              position.coords.longitude,
              position.coords.latitude,
            ]);
          },
          (err) => console.log('Geolocation error:', err),
          { enableHighAccuracy: true, timeout: 5000 }
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Puxa as informações da API da SS de location (contém as coordenadas dos pontos e as coordenadas da rota)
  const getLocation = async () => {
    if (
      (blsi != null || blsi != undefined) &&
      (formValues.viagem == null || formValues.viagem == undefined)
    ) {
      setload(true);
      api
        .get(`/busline/shift/locations?bus_line_shift_id=${blsi}`)
        .then((resp) => {
          const dataLocation = resp.data;

          if (dataLocation) {
            dataLocation[0].poi.map((c)=>{
              coordenadas.push([c.latitude,c.longitude])
            })

            let bl = dataLocation[0];

            if (bl.buslineshift.route.coordinates) {
              let coordinates = [];
              bl.buslineshift.route.coordinates.map((item) =>
                coordinates.push([
                  parseFloat(item.split(" ")[1]),
                  parseFloat(item.split(" ")[0]),
                ])
              );

              bl.buslineshift.route.coordinates = coordinates;
              setBusline(bl);

            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(function () {
          setload(false);
        });
    } else {
      if (formValues.viagem != null || formValues.viagem != undefined) {
        setload(true);
        api
        .get(
          `/busline/shift/locations?bus_line_shift_id=${formValues.viagem}`
          )

          .then((resp) => {
            const dataLocation = resp.data;
            if (dataLocation) {
                dataLocation[0].poi.map((c)=>{
                  coordenadas.push([c.latitude,c.longitude])
                })

                let bl = dataLocation[0];

              if (bl.buslineshift.route.coordinates) {
                let coordinates = [];
                bl.buslineshift.route.coordinates.map((item) =>
                  coordinates.push([
                    parseFloat(item.split(" ")[1]),
                    parseFloat(item.split(" ")[0]),
                  ])
                );

                bl.buslineshift.route.coordinates = coordinates;
              } else {
                bl.buslineshift.route.coordinates = null;
              }
              if (dataLocation[0].poi === null) {
                bl.poi = null;
              }

              setBusline(bl);
            }
            localStorage.removeItem("BuslineShiftID");
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(function () {
            setload(false);
          });
      }
    }
  };

  //Busca o nome do endereço ao enviar a latitude e a longitude
  const endereco = () => {
    if(busline==null || busline==undefined) return;
    if(busline.length ==0) return;
    try {
      coordenadas.map(async (c)=>{
        const res = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${c[1]},${c[0]}.json?access_token=${token}`
          );
          if (res.status === 200) {
          setEnderecos((prevEnd) => [...prevEnd, res.data.features[0].place_name])
          return res.data.features[0].place_name;
        }
      })
    } catch (error) {
      console.log(error);
    }
  };

  //Desenha a rota que a unidade irá fazer para aquela determinada viagem/linha
  const DrawRoute = async () => {
    if (busline.length === 0) return;
    if (!busline.buslineshift.route.coordinates || busline === null) return;

    let coordinates = await busline.buslineshift.route.coordinates;
    let color = await busline.buslineshift.route.color;
    if ((await busline.poi) != undefined || (await busline.poi) != null) {
      map.addSource("route", {
        type: "geojson",
        data: {
          type: "Feature",
          properties: {},
          geometry: {
            type: "LineString",
            coordinates: coordinates,
          },
        },
      });

      map.addLayer({
        id: "route",
        type: "line",
        source: "route",
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": color,
          "line-width": 4,
        },
      });
      // ----------------------------------------------
      let bounds = coordinates.reduce(function (bounds, coord) {
        return bounds.extend(coord);
      }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

      // Incluir localização do usuário no bounds
      const savedAddr = JSON.parse(localStorage.getItem("addressListFix"));
      if (savedAddr && savedAddr.length > 0 && savedAddr[0].coords) {
        bounds.extend([savedAddr[0].coords[0], savedAddr[0].coords[1]]);
      } else if (markerUser) {
        const userLngLat = markerUser.getLngLat();
        if (userLngLat.lng !== -47.4197) bounds.extend([userLngLat.lng, userLngLat.lat]);
      }

      map.fitBounds(bounds, { padding: 40, duration: 800 });
      setRouteIsTrue(true);
    }
  };

  //Puxa as informações da API da SS de schedule (contém as informações dos pontos como nome, tipo de ponto, ordem, etc)
  const getSchedule = async () => {
    if (
      (blsi != null || blsi != undefined) &&
      (formValues.viagem == null || formValues.viagem == undefined)
    ) {
      api
      .get(`/busline/shift/schedule?bus_line_shift_id=${blsi}`)
      .then((resp) => {
        const dataLocation = resp.data;
        setschedulePoint(dataLocation[0]);
      })
      .catch((error) => {
        console.log(error);
      });
    } else {
      if (formValues.viagem != null || formValues.viagem != undefined) {
        api
        .get(`/busline/shift/schedule?bus_line_shift_id=${formValues.viagem}`)
        .then((resp) => {
          const dataLocation = resp.data;
          setschedulePoint(dataLocation[0]);

            localStorage.removeItem("BuslineShiftID");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  //Função que monta e mostra o popup ao clicar em um ponto
  const PointPopout = (e, popup) => {
    const coordinates = e.features[0].geometry.coordinates.slice();
    const p = document.createElement("p");
    const div = document.createElement("div");

    while (Math.abs(e.lngLat.lng - coordinates[0]) > 200) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }

    p.innerHTML = `${e.features[0].properties.name}`;
    div.appendChild(p);
    popup.setLngLat(coordinates).setDOMContent(div).addTo(map);
  };

  //Desenha os pontos onde a unidade irá passar para aquela determinada viagem/linha
  const DrawPoint = () => {
    if (!busline.poi || busline === null) return;
    let features = [];
    let features1 = [];
    if (busline.poi != undefined || busline.poi != null) {
      busline.poi.map((item, index) => {
        features.push({
          type: "Feature",
          properties: {
            id: item.id,
            name: item.name,
            latitude: item.latitude,
            longitude: item.longitude,
            hour: item.hour,
            enderecoPonto: enderecos[index]
              ? enderecos[index]
              : "Endereco nao encontrado",
            message: index + 1,
            realtime: schedulePoint
              ? schedulePoint.stops
                ? schedulePoint.stops[index].real_time
                : "010101"
              : "010101",
          },
          geometry: {
            type: "Point",
            coordinates: [item.longitude, item.latitude],
          },
        });
      });

      //Salva o primeiro e o último ponto em features1
      features1.push(features[0]);
      features1.push(features[features.length - 1]);

      //Removo o primeiro e o último ponto em features
      features.splice(features.length - 1, 1);
      features.splice(0, 1);

      map.addSource("places1", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: features1,
        },
      });
      map.addLayer({
        id: "places1",
        type: "circle",
        source: "places1",
      });

      map.addSource("places", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: features,
        },
      });

      map.addLayer({
        id: "places",
        type: "circle",
        source: "places",
      });

      for (const marker1 of features) {
        const el = document.createElement("div");
        const el1 = document.createTextNode(`${marker1.properties.message}`);
        el.className = "marker";
        el.style.width = `28px`;
        el.style.height = `28px`;
        el.style.textAlign = `center`;
        el.style.alignSelf = `center`;
        el.style.padding = `2px`;
        el.style.color = `white`;
        el.style.borderRadius = `50px`;
        el.style.border = `2px solid white`;
        el.style.fontWeight = `800`;
        el.style.zIndex = "1";

        if (marker1.properties.realtime === null) {
          el.style.backgroundColor = `#adb5bd`;
        } else {
          el.style.backgroundColor = `#213f9a`;
          el.style.boxShadow = `0 0 0 3px rgba(33,63,154,0.2)`;
        }

        el.appendChild(el1);

        //insiro no mapa o ponto azul/cinza na
        pontos.push(
          new mapboxgl.Marker(el)
            .setLngLat(marker1.geometry.coordinates)
            .addTo(map)
        );

        el.addEventListener("click", function () {
          if (popupOpen || popupOpen == null)
            localStorage.setItem("popup", "true");
          setPopupInfos([
            marker1.properties.name,
            marker1.properties.enderecoPonto,
          ]);
        });

        //função em javascript para passar o mouse e o cursor virar ponteiro nos pontos, exceto o ponto
        //inicial e final
        el.addEventListener("mouseover", function (e) {
          e.target.style.cursor = "pointer";
        });
      }

      const el2 = document.createElement("div");
      const el3 = document.createElement("img");
      el3.src = iconPI;
      el3.className = "pontoIniImg";
      el3.style.marginTop = "3px";
      el2.className = "pontoIniDiv";
      el2.style.width = `28px`;
      el2.style.height = `28px`;
      el2.style.padding = `2px`;
      el2.style.textAlign = `center`;
      el2.style.alignSelf = `center`;
      el2.style.backgroundColor = `#76c24e`;
      el2.style.borderRadius = `50px`;
      el2.style.border = `2px solid white`;
      el2.style.zIndex = "1";
      el2.appendChild(el3);

      el2.addEventListener("click", (e) => {
        if (popupOpen || popupOpen == null)
          localStorage.setItem("popup", "true");

        setPopupInfos([
          features1[0].properties.name,
          features1[0].properties.enderecoPonto,
        ]);
      });

      //função em javascript para passar o mouse e o cursor virar ponteiro no ponto inicial
      el2.addEventListener("mouseover", function (e) {
        e.target.style.cursor = "pointer";
      });

      setpontoIni(
        new mapboxgl.Marker(el2)
          .setLngLat(features1[0].geometry.coordinates)
          .addTo(map)
      );

      const el4 = document.createElement("div");
      const el5 = document.createElement("img");
      el5.src = iconPI;
      el5.className = "pontofimImg";
      el5.style.marginTop = "3px";
      el4.className = "pontofimDiv";
      el4.style.width = `28px`;
      el4.style.height = `28px`;
      el4.style.padding = `2px`;
      el4.style.textAlign = `center`;
      el4.style.alignSelf = `center`;
      el4.style.backgroundColor = `#B80000`;
      el4.style.borderRadius = `50px`;
      el4.style.border = `2px solid white`;
      el4.style.zIndex = "1";

      //função em javascript para passar o mouse e o cursor virar ponteiro no ponto final
      el4.addEventListener("mouseover", function (e) {
        e.target.style.cursor = "pointer";
      });

      el4.appendChild(el5);

      setpontoFim(
        new mapboxgl.Marker(el4)
          .setLngLat(features1[1].geometry.coordinates)
          .addTo(map)
      );

      el4.addEventListener("click", function () {
        if (popupOpen || popupOpen == null)
          localStorage.setItem("popup", "true");
        setPopupInfos([
          features1[1].properties.name,
          features1[1].properties.enderecoPonto,
        ]);
      });

      setPointIsTrue(true);

      const popup = new mapboxgl.Popup({
        offset: 20,
      });

      if (!eventClick) {
        setEventClick(true);
        map.on("click", "places1", (e) => PointPopout(e, popup));
        map.on("click", "places", (e) => PointPopout(e, popup));
      }
    }
  };

  // Desenha ou atualiza o rastro do veículo no mapa
  const updateVehicleTrail = (lng, lat) => {
    if (!map || !map.isStyleLoaded()) return;

    const lastPos = vehicleTrail.current[vehicleTrail.current.length - 1];
    if (lastPos && lastPos[0] === lng && lastPos[1] === lat) return;

    vehicleTrail.current.push([lng, lat]);

    const trailData = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: vehicleTrail.current,
      },
    };

    if (map.getSource("vehicle-trail")) {
      map.getSource("vehicle-trail").setData(trailData);
    } else {
      map.addSource("vehicle-trail", {
        type: "geojson",
        data: trailData,
      });
      map.addLayer({
        id: "vehicle-trail",
        type: "line",
        source: "vehicle-trail",
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#1b9e3e",
          "line-width": 5,
          "line-opacity": 0.85,
          "line-dasharray": [0.5, 2.5],
        },
      });
    }
  };

  // Interpola suavemente entre pontos da rota usando requestAnimationFrame
  const animateAlongRoute = (routeCoords, duration) => {
    if (!routeCoords || routeCoords.length < 2) return;

    // Calcula distâncias acumuladas entre pontos para interpolação uniforme
    const distances = [0];
    for (let i = 1; i < routeCoords.length; i++) {
      const dx = routeCoords[i][0] - routeCoords[i - 1][0];
      const dy = routeCoords[i][1] - routeCoords[i - 1][1];
      distances.push(distances[i - 1] + Math.sqrt(dx * dx + dy * dy));
    }
    const totalDist = distances[distances.length - 1];
    if (totalDist === 0) return;

    const startTime = performance.now();

    const step = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      // Ease-in-out para movimento mais natural
      const eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

      const targetDist = eased * totalDist;

      // Encontra o segmento atual
      let segIdx = 0;
      for (let i = 1; i < distances.length; i++) {
        if (distances[i] >= targetDist) { segIdx = i - 1; break; }
        segIdx = i - 1;
      }

      // Interpola dentro do segmento
      const segStart = distances[segIdx];
      const segEnd = distances[segIdx + 1] || segStart;
      const segLen = segEnd - segStart;
      const segT = segLen > 0 ? (targetDist - segStart) / segLen : 0;

      const lng = routeCoords[segIdx][0] + (routeCoords[segIdx + 1][0] - routeCoords[segIdx][0]) * segT;
      const lat = routeCoords[segIdx][1] + (routeCoords[segIdx + 1][1] - routeCoords[segIdx][1]) * segT;

      marker.setLngLat([lng, lat]);
      updateVehicleTrail(lng, lat);

      // Centraliza o mapa no veículo suavemente
      map.easeTo({ center: [lng, lat], duration: 0 });

      if (t < 1) {
        animationRef.current = requestAnimationFrame(step);
      }
    };

    animationRef.current = requestAnimationFrame(step);
  };

  // Distância em metros entre dois pontos [lng, lat] usando Haversine
  const haversineMeters = (lng1, lat1, lng2, lat2) => {
    const R = 6371000;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  // Encontra o índice do ponto mais próximo na rota planejada
  const findClosestRouteIndex = (lng, lat, routeCoords) => {
    let minDist = Infinity;
    let minIdx = 0;
    for (let i = 0; i < routeCoords.length; i++) {
      const d = haversineMeters(lng, lat, routeCoords[i][0], routeCoords[i][1]);
      if (d < minDist) { minDist = d; minIdx = i; }
    }
    return { index: minIdx, distance: minDist };
  };

  // Extrai trecho da rota planejada entre dois posições
  const getPlannedRouteSegment = (prevLng, prevLat, newLng, newLat) => {
    if (!busline || !busline.buslineshift || !busline.buslineshift.route || !busline.buslineshift.route.coordinates) return null;
    const planned = busline.buslineshift.route.coordinates;
    if (planned.length < 2) return null;

    const TOLERANCE = 200; // 200 metros

    const from = findClosestRouteIndex(prevLng, prevLat, planned);
    const to = findClosestRouteIndex(newLng, newLat, planned);

    // Se ambos os pontos estão dentro da tolerância da rota
    if (from.distance < TOLERANCE && to.distance < TOLERANCE) {
      const startIdx = Math.min(from.index, to.index);
      const endIdx = Math.max(from.index, to.index);

      if (endIdx - startIdx < 1) return null; // Muito próximos na rota

      // Extrai o trecho: ponto atual → segmento da rota → novo ponto
      const segment = [
        [prevLng, prevLat],
        ...planned.slice(startIdx, endIdx + 1),
        [newLng, newLat],
      ];
      return segment;
    }

    return null; // Fora da rota
  };

  // Anima o veículo: rota planejada se possível, senão Directions API, senão linear
  const animateVehicleTo = async (newLng, newLat) => {
    const prev = lastVehiclePos.current;
    lastVehiclePos.current = [newLng, newLat];

    if (!prev || !marker) {
      marker.setLngLat([newLng, newLat]);
      updateVehicleTrail(newLng, newLat);
      return;
    }

    // Se a distância é muito pequena (< 10m), pular animação
    if (haversineMeters(prev[0], prev[1], newLng, newLat) < 10) return;

    // Cancelar animação anterior
    if (animationRef.current) cancelAnimationFrame(animationRef.current);

    const duration = 9000;

    // 1. Tentar usar a rota planejada
    const plannedSegment = getPlannedRouteSegment(prev[0], prev[1], newLng, newLat);
    if (plannedSegment && plannedSegment.length >= 2) {
      animateAlongRoute(plannedSegment, duration);
      return;
    }

    // 2. Fallback: Mapbox Directions API (veículo fora da rota)
    try {
      const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${prev[0]},${prev[1]};${newLng},${newLat}?geometries=geojson&overview=full&access_token=${token}`;
      const res = await axios.get(url);
      const route = res.data?.routes?.[0]?.geometry?.coordinates;

      if (route && route.length >= 2) {
        animateAlongRoute(route, duration);
        return;
      }
    } catch (e) { /* fallback abaixo */ }

    // 3. Fallback final: interpolação linear
    animateAlongRoute([prev, [newLng, newLat]], duration);
  };

  // Posiciona o veículo (com ou sem animação)
  const positionVehicle = (lng, lat) => {
    const fLng = parseFloat(lng);
    const fLat = parseFloat(lat);
    elementCar.style.display = "block";

    if (lastVehiclePos.current) {
      animateVehicleTo(fLng, fLat);
    } else {
      lastVehiclePos.current = [fLng, fLat];
      marker.setLngLat([fLng, fLat]);
      updateVehicleTrail(fLng, fLat);
    }
  };

  //Busca a localização da unidade. Se tiver realtime a unidade aparece no mapa,
  //se não, ela não aparece
  const getBusLocationRealTime = async () => {
    try {
      if (blsi != null || blsi != undefined) {
        const res = await api.get(
          `/busline/shift/schedule?bus_line_shift_id=${blsi}`
        );

        if (res.data[0].dev_status.id != null) {
          positionVehicle(res.data[0].dev_status.longitude, res.data[0].dev_status.latitude);
        } else {
          elementCar.style.display = "none";
        }

      }
      if (formValues.viagem != null || formValues.viagem != undefined) {
        const res = await api.get(
          `/busline/shift/schedule?bus_line_shift_id=${formValues.viagem}`
        );
        if (res.data[0].dev_status.id != null) {
          positionVehicle(res.data[0].dev_status.longitude, res.data[0].dev_status.latitude);
        } else {
          elementCar.style.display = "none";
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //UseEffect para inicializar o mapa
  useEffect(() => {
    if (!map || formValues.viagem != null) {
      // se o mapa nao iniciar, forca a inicializacao
      setMap(
        new mapboxgl.Map({
          container: mapContainerRef.current,
          style: "mapbox://styles/mapbox/streets-v11",
          center: [-47.4197, -20.5418],
          zoom: 5,
        })
      );
      return;
    }

    map.on('style.load', () => setMapReady(true));

    setLocationsMarker([
      {
        type: "Feature",
        properties: {
          title: "Localizacao atual",
          description: "Onde o usuario esta no momento",
        },
        geometry: {
          coordinates: [-47.4197, -20.5418],
          type: "Point",
        },
      },
    ]);
    // Clean up on unmount
    return () => map.remove();
  }, [map]);

  //UseEffect para inicializar os marcadores da localização do usuário e da localização da unidade
  useEffect(() => {
    if (!map) return;
    let element = "";
    if (!marker) {
      // seta uma posicao inicial da unidade, na primeira vez
      setMarker(
        new mapboxgl.Marker((element = document.getElementById("marked")))
          .setLngLat([-47.4197, -20.5418])
          .addTo(map)
      );
      element.style.display = "none";
      setelementCar(element);

      if (!markerUser) {
        // seta uma posição inicial do usuário, na primeira vez
        setMarkerUser(
          new mapboxgl.Marker((element = document.getElementById("you")))
            .setLngLat([-47.4197, -20.5418])
            .addTo(map)
        );
      }
    } else {
      if (marker !== null) {
        marker.remove();
      }
      setMarkerUser(
        new mapboxgl.Marker((element = document.getElementById("you")))
          .setLngLat([-47.4197, -20.5418])
          .addTo(map)
      );
    }

    return () => {
      // remove a posição para atualizar depois no mapa
      if (markerUser !== null) markerUser.remove();
      if (marker !== null) marker.remove();
    };
  }, [locationsMarker]);

  //UseEffect para atualizar a posição do usuário de tempos em tempos
  useEffect(() => {
    //Se o mapa e o marcador do usuário não existir, ignora
    if (!map || !markerUser) return;
    if (reloadUserRoute) clearInterval(reloadUserRoute);
    reloadUserRoute = setTimeout(getCurrentLocationOfUser, timerUserReload);
  }, [map, markerUser, marker]);

  //UseEffect para chamar novamente as APIs de location e schedule quando houver alteração no dropdown
  useEffect(() => {
    getLocation();
    getSchedule();
  }, [formValues.viagem]);

  // Pulsa o botão Pontos quando os dados da viagem carregam
  useEffect(() => {
    if (schedulePoint && !modalPonto) {
      setPulsePoints(true);
      const timer = setTimeout(() => setPulsePoints(false), 4000);
      return () => clearTimeout(timer);
    }
  }, [schedulePoint != null]); // eslint-disable-line

  useEffect(()=>{
    endereco();
  },[busline])

  // Centraliza no usuário se não houver rota carregada
  useEffect(() => {
    if (!map || !mapReady || load) return;
    if (busline && busline.buslineshift) return; // tem rota, não precisa
    const savedAddr = JSON.parse(localStorage.getItem("addressListFix"));
    if (savedAddr && savedAddr.length > 0 && savedAddr[0].coords) {
      if (markerUser) markerUser.setLngLat([savedAddr[0].coords[0], savedAddr[0].coords[1]]);
      map.flyTo({ center: [savedAddr[0].coords[0], savedAddr[0].coords[1]], zoom: 13, speed: 3 });
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        const coords = [pos.coords.longitude, pos.coords.latitude];
        if (markerUser) markerUser.setLngLat(coords);
        map.flyTo({ center: coords, zoom: 13, speed: 3 });
      });
    }
  }, [mapReady, load, busline]);

  //UseEffect para montar e desmontar o desenho da rota no mapa
  useEffect(() => {
    if (!map || !mapReady) return;
    if (busline === undefined || busline === null) return;
    if (busline.buslineshift === undefined || busline.buslineshift === null)
      return;
    if (routeIsTrue === true) {
      if (map.getLayer("route")) map.removeLayer("route");
      if (map.getSource("route")) map.removeSource("route");
    }
    setRouteIsTrue(false);
    DrawRoute();
  }, [busline.buslineshift, formValues.viagem, mapReady]);

  //UseEffect para montar e desmontar o desenho dos pontos no mapa
  useEffect(() => {
    if (!map || !mapReady) return;
    if (busline === undefined || busline === null) return;
    if (busline.buslineshift === undefined || busline.buslineshift === null)
      return;
    if (enderecos === undefined || enderecos === null) return;

    if (pointIsTrue === true) {
      if (map.getLayer("places")) map.removeLayer("places");
      if (map.getSource("places")) map.removeSource("places");
      if (map.getLayer("places1")) map.removeLayer("places1");
      if (map.getSource("places1")) map.removeSource("places1");
    }
    setPointIsTrue(false);
    if (pontoFim != null && pontoIni != null && pontos != null) {
      pontoFim.remove();
      pontoIni.remove();
      for (let a = pontos.length - 1; a >= 0; a--) {
        pontos[a].remove();
      }
    }

    DrawPoint();
  }, [busline.poi, formValues.viagem, schedulePoint, enderecos, mapReady]);

  //UseEffect para atualizar a posição da unidade de tempos em tempos
  useEffect(() => {
    if (!map || !markerUser) return;

    setTimeout(() => {
      getBusLocationRealTime();
    }, 1000);

    const int = setInterval(() => {
      getBusLocationRealTime();
    }, 10000);

    return () => {
      clearInterval(int);
    };
  }, [marker, formValues.viagem, markerUser, blsi]);

  // UseEffect para atualizar a função do schedule para receber o realtime de tempos em tempos
  useEffect(() => {
    if (!map || !marker) return;
    setTimeout(() => {
      getSchedule();
    }, 1000);

    const int = setInterval(() => {
      getSchedule();
    }, 30000);

    return () => {
      clearInterval(int);
    };
  }, [marker, formValues.viagem]);

  const locateClickCount = useRef(0);
  const locateClickTimer = useRef(null);

  const centerOnUser = () => {
    locateClickCount.current += 1;

    if (locateClickTimer.current) clearTimeout(locateClickTimer.current);

    locateClickTimer.current = setTimeout(() => {
      const withZoom = locateClickCount.current >= 2;
      locateClickCount.current = 0;

      if (!map) return;
      const savedAddress = JSON.parse(localStorage.getItem("addressListFix"));
      const opts = { speed: 3 };
      if (withZoom) opts.zoom = 15;

      if (savedAddress && savedAddress.length > 0 && savedAddress[0].coords) {
        const coords = [savedAddress[0].coords[0], savedAddress[0].coords[1]];
        if (markerUser) markerUser.setLngLat(coords);
        map.flyTo({ center: coords, ...opts });
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          const coords = [pos.coords.longitude, pos.coords.latitude];
          if (markerUser) markerUser.setLngLat(coords);
          map.flyTo({ center: coords, ...opts });
        });
      }
    }, 300);
  };

  const hasData = schedulePoint != null || schedulePoint != undefined;

  return (
    <>
      {load ? <Load /> : null}
      <MapaDiv>
        <Menu transparent />

        <MapActionBtn top="60px" onClick={centerOnUser} aria-label="Centralizar na minha localização">
          <IconMD.MdMyLocation />
        </MapActionBtn>
        <MapActionBtn
          top="108px"
          onClick={() => {
            if (!map) return;
            if (!busline || !busline.buslineshift || !busline.buslineshift.route || !busline.buslineshift.route.coordinates) return;
            const coords = busline.buslineshift.route.coordinates;
            const bounds = coords.reduce(
              (b, c) => b.extend(c),
              new mapboxgl.LngLatBounds(coords[0], coords[0])
            );
            if (marker) {
              const vPos = marker.getLngLat();
              bounds.extend([vPos.lng, vPos.lat]);
            }
            map.fitBounds(bounds, { padding: 40, duration: 800 });
          }}
          aria-label="Centralizar na rota"
        >
          <IconMD.MdDirectionsBus />
        </MapActionBtn>

        {modalPonto && hasData ? (
          <ModalPonto
            data={{
              locationsPoint: busline,
              schedulePoint: schedulePoint,
              enderecos: enderecos,
            }}
            onClose={() => setModalPonto(false)}
          />
        ) : null}
        {modalInfo && busline && busline.buslineshift ? (
          <ModalInfo
            data={{
              locationsPoint: busline,
              schedulePoint: schedulePoint,
              enderecos: enderecos,
            }}
            onClose={() => setModalInfo(false)}
            onCenterRoute={() => {
              if (!map || !busline || !busline.buslineshift || !busline.buslineshift.route || !busline.buslineshift.route.coordinates) return;
              const coords = busline.buslineshift.route.coordinates;
              const bounds = coords.reduce(
                (b, c) => b.extend(c),
                new mapboxgl.LngLatBounds(coords[0], coords[0])
              );
              map.fitBounds(bounds, { padding: 50, duration: 800 });
            }}
          />
        ) : null}

        {hasData && (
          <InfoButton
            pulse={pulsePoints && !modalPonto ? 1 : 0}
            onClick={() => { setModalPonto(!modalPonto); setPulsePoints(false); }}
          >
            <IconMD.MdListAlt style={{ fontSize: 20 }} />
            <span>Pontos</span>
          </InfoButton>
        )}

        {busline && busline.buslineshift && (
          <InfoButton
            style={{ left: hasData ? 130 : 16 }}
            onClick={() => setModalInfo(true)}
          >
            <IconMD.MdOutlineInfo style={{ fontSize: 20 }} />
            <span>Info</span>
          </InfoButton>
        )}

        <div className="map-container" ref={mapContainerRef} />
        <div id="marked"></div>
        <div id="you" />
      </MapaDiv>
    </>
  );
};

export default Map;
